import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Post        from '@common/post/_post';

// -------------------------------------------------------


class ReportList extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.score = {};
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      product_type : 'all',
      sort         : 'post_date:desc',
    };
  }
  // -------------------------------------------------------
  
  /*
   * 設定の変更
   */
  changeSetting(product_type) {
    this.setState({ product_type: this.product_type.value, sort: this.sort.value });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    // 存在しない場合
    if( data.report.list.length == 0 ){
      return (
        <div className="report-members">
          <div className="report-none">投稿がありません</div>
        </div>
      );
    }
    
    // コンテンツタイプ設定
    let contents_types = [];
    for( let i in Const.value.contents_type ) contents_types.push({ id: i, name: Const.value.contents_type[i] });
    
    // 表示設定
    let reports = [];
    data.report.list.map((d) => {
      if( this.state.product_type != 'all' && d.product_type != this.state.product_type ) return;
      if( this.props.is_check === true && d.is_insight_update == 1 ) return;
      reports.push(d);
    });
    
    let sort = this.state.sort.split(':');
    reports = Utils.sort(reports, sort[0], sort[1]);
    
    return (
      <div className="report-post-list">
        <div className="list-header">
          
          <div className="product-type-select">
            <h6>投稿種別</h6>
            <div className="selectbox">
		          <select ref={(input) => { this.product_type = input }} onChange={this.changeSetting.bind(this)}>
		            <option value="all">全て表示</option>
                { contents_types.map((d, key) => {
		              return <option key={key} value={d.id}>{d.name}</option>
		            })}
		          </select>
		        </div>
		      </div>
		      
          <div className="sort-select">
            <h6>並び順</h6>
            <div className="selectbox">
		          <select ref={(input) => { this.sort = input }} onChange={this.changeSetting.bind(this)}>
		            <option value="post_date:desc">投稿日時が新しい</option>
		            <option value="post_date:asc">投稿日時が古い</option>
		            <option value="likes:desc">いいね数が多い</option>
		            <option value="reach:desc">リーチ数が多い</option>
		          </select>
		        </div>
		      </div>
		      
        </div>
        <div className="list-items">
          { reports.map((d, key) => {
            let account = {};
            try { account = data.workflow.influencers[d.insta_user_id]; } catch(e) {}
            
            try {
              return (
                <div key={key} className={'list-items-contents post_type_'+ d.product_type.toLowerCase() }>
                  <Post data={d} base={data} account={account} report={d} />
                  {/* (d.is_insight_update == 0) && <div className="list-items-pop" /> */}
                </div>
              );
            } catch(e) {
              return null;
            }
          })}
          
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportList;